import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormField } from '../../../interfaces/FormField';

@Component({
  selector: 'ngx-header-importacao',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() titlePage: string;
  @Input() formFields: FormField[];
  @Output() action: EventEmitter<void> = new EventEmitter<void>();

  public customLogin = null;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    const resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);

    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({});
    this.formFields.forEach(field => {
      this.form.addControl(field.name, this.formBuilder.control(field.value || ''));
    });
  }

  dateSelect(event: any, fieldName: string) {
    this.formFields.forEach(field => {
      if (field.type === 'datepicker' && field.name === fieldName) {
        this.form.patchValue({ [field.name]: event.formatted }, { emitEvent: false });
      }
    });
  }
  
  filter() {
    this.action.emit(this.form.value);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

}
